module.exports = __webpack_public_path__ + "static/media/zoom-out-black.2c5f52f5.svg";